import {useContext} from 'react';
import {runInAction} from "mobx";

import ajaxGetQueue, {watsonGetQueue} from "../backends/AjaxQueue";
import { DefaultController } from "../backends/YiiRoutes";
import {isJson} from "../components/admin/spinup/utilities";
import {StoreContext} from "../stores/StoreLoader";
import WatsonApi from "../backends/WatsonApi";
import useAsyncEffect from "./useAsyncEffect";

export default function useFinalizeBlock(blockObj, isPreviewBlock) {
    const {i18nStore, organizationStore, userStore} = useContext(StoreContext);

    useAsyncEffect(async () => {
        if (!isPreviewBlock) {
            function legacyFinalizeBlock() {
                const blockID = blockObj.id;
                const task = {
                    orgID: organizationStore.currentOrganization.id,
                    url: DefaultController.blockFetch(i18nStore.currentOrgSupportedLocale, blockID),
                    data: {
                        'sizeX': blockObj.sizeX,
                        'sizeY': blockObj.sizeY,
                        'useAbsoluteUrls': true,
                        'usingReact': true,
                        'swcache': true, // caught be service worker
                    },
                    dataType: 'json',
                };

                ajaxGetQueue.push(task, 10, (err, data) => {
                    if (data?.html && isJson(data.html)) {
                        runInAction(() => {
                            const newSettings = JSON.parse(data.html);
                            if (blockObj.setAttributes) {
                                blockObj.setAttributes({
                                    ...newSettings,
                                    asyncLoaded: true,
                                });
                            }
                        })
                    }
                });
            }

            if (blockObj.blockType === "sharedfiles") {
                const client = await WatsonApi();
                const task = {
                    url: client.organizations['organizations_content_sources_list'],
                    params: {
                        organization_pk: blockObj.id,
                        expand: ["items"],
                    }
                }
                watsonGetQueue.push(task, 10, result => {
                    const contentSources = JSON.parse(result.data).data;
                    if (contentSources?.length > 0) {
                        runInAction(() => {
                            blockObj.setAttributes({
                                contentSources,
                                asyncLoaded: true,
                            });
                        })
                    } else {
                        legacyFinalizeBlock();
                    }
                });
            } else if (blockObj.loadAsync) {
                // should only run for async blocks that haven't been converted over to Watson yet
                legacyFinalizeBlock();
            }
        }
    }, [blockObj.blockType]);
    // this is here so in ToolDrawerGrid -> ExampleBlock we update the block from loading to whatever when we get a new blockObj
    if (!isPreviewBlock && !blockObj.loadAsync && isJson(blockObj.htmlOutput)) {
        runInAction(() => {
            let newSettings = JSON.parse(blockObj.htmlOutput);
            const newBlockObj = newSettings?.blockObj;
            // for some reason the youtube/video blocks send blockObj as htmlOutput instead of filling the htmlOutput.
            if (newBlockObj) newSettings = {...newSettings, ...newBlockObj};
            if (blockObj.setAttributes) {
                blockObj.setAttributes({...newSettings});
            }
        })
    }
}
